var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6367 15.3386C37.6953 15.7199 37.622 16.5559 37.622 16.5559C37.2847 19.5773 35.4367 21.3813 32.3127 21.3813C29.0127 21.3813 26.6807 19.0346 26.6807 15.7053C26.6807 12.3759 29.0127 10.0439 32.3127 10.0439C35.8327 10.0439 37.1087 12.7133 37.1087 12.7133L35.246 13.7546C35.246 13.7546 34.3953 11.9799 32.298 11.9799C30.2153 11.9799 28.91 13.4173 28.91 15.7053C28.91 18.0079 30.2153 19.4453 32.298 19.4453C33.6473 19.4453 35.3487 18.8439 35.3927 17.0986H32.5913V15.3386H37.6367Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6497 10.1466V21.2639H23.127L17.8324 13.6079V21.2639H15.603V10.1466H18.1257L23.4204 17.8466V10.1466H25.6497Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3515 10.1466V12.0533H8.41146V14.5906H13.5741V16.4973H8.41146V19.3573H14.3515V21.2639H6.18213V10.1466H14.3515Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEng);
export default __webpack_public_path__ + "static/media/icon_eng.224ae5f13c37191fe8dd648737ee9388.svg";
export { ForwardRef as ReactComponent };